import React, { useEffect } from 'react';

const WorkflowActions = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: WorkflowActions is not implemented yet.');
  }, []);
  return (
    <>
  { /*WorkflowActions */} 
 </>
  );
};

export default WorkflowActions;
